<div class="tree-container flex flex-row justify-stretch items-stretch full-grow-no-shrink-no-basis">
  <mat-tree class="custom-tree" [dataSource]="dataSource" [treeControl]="treeControl" cdkDropList
            (cdkDropListDropped)="drop($event)">
    <mat-tree-node class="custom-tree-node" style="position:relative" [id]="node.id"
                   [ngClass]="{'control-show': node.item.id === selectedNodeId,'frozen-node':node.item.frozen==true,'excluded-item':node.item.isHidden==true || node.item.isParentHidden==true}"
                   attr.question-id="{{node.item.questionId}}" (click)="onSelectedNode(node); $event.stopPropagation();"
                   *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding cdkDrag [cdkDragData]="node"
                   (mouseenter)="dragHover(node)" (mouseleave)="dragHoverEnd()" (cdkDragStarted)="dragStart()"
                   (cdkDragReleased)="dragEnd()">

      <div class="node-wrapper w-p-100 flex flex-row justify-start items-center"
           [ngClass]="{'state-highlight': node.item.id === selectedNodeId}">
        <div class="left-section flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
          <div class="button-container">

          </div>
          <div class="content-container flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
            <div *ngIf="node.item?.conditionDisplayText && node.item?.conditionDisplayText.length>0"
                 class="tagg flex flex-row justify-start items-center">
              <div class="custom-icon flex flex-col">
                <span></span>
                <span></span>
              </div>
              {{node.item?.conditionDisplayText}}</div>
            <div class="content flex flex-row justify-start items-start full-grow-no-shrink-no-basis">
              <div>{{node.item?.questionId}}.</div>
              <div class="m-l-5">{{node.item?.title}}.</div>
              <div *ngIf="node.item?.isMandatory">&nbsp;*</div>
              <div class="description flex-1-0-auto"
                   title="{{node.item?.instruction ? node.item?.instruction : ''}}"> {{node.item?.instruction ? node.item?.instruction : ''}}</div>
            </div>
          </div>
        </div>
        <div *ngIf="isManageFields" class="right-section m-r-14">
          <button mat-icon-button [matMenuTriggerFor]="actionMenu"
                  class="no-animation-btn icon-dropdown-button">
            <mat-icon class="s-20">more_horiz</mat-icon>
          </button>
          <mat-menu #actionMenu="matMenu" class="action-button-dropdown-container" [overlapTrigger]="false">
            <button *ngIf="!node.item.isHidden" mat-menu-item class="" (click)="openDetailsPopUp(node)">
              <span>View Details</span>
            </button>
            <button *ngIf=" !node.item.isHidden" mat-menu-item class="" (click)="onAdd(node,true)" matTooltip="Note: Adding a new Field or Sub-Field to your Data
            Survey means any responses given for this field will be stored inside ITP in the relevant source data screen.">
              <span>Add Field</span>
            </button>
            <button *ngIf="!node.item.isHidden && !node.item.frozen && !node.item.identityField" mat-menu-item class=""
                    (click)="editQuestion(node)">
              <span>Edit Field</span> <!--{{node.item?.questionType}}-->
            </button>
            <button *ngIf="!node.item.isHidden && !node.item.frozen && !node.item.identityField && node.item.isCustom"
                    mat-menu-item class="" (click)="delete(node)">
              <span>Delete Field</span>
            </button>
          </mat-menu>
        </div>
        <div *ngIf="!isManageFields" class="right-section m-r-14">
          <button mat-icon-button [matMenuTriggerFor]="actionMenu"
                  class="no-animation-btn icon-dropdown-button">
            <mat-icon class="s-20">more_horiz</mat-icon>
          </button>
          <mat-menu #actionMenu="matMenu" class="action-button-dropdown-container" [overlapTrigger]="false">
            <button *ngIf="!node.item.isHidden" mat-menu-item class="" (click)="openDetailsPopUp(node)">
              <span>View Details</span>
            </button>
            <!--<button *ngIf=" !node.item.isHidden" mat-menu-item class=""  (click)="showFlowchartWarning()"  matTooltip="">
              <span>Add Field</span>
            </button>-->
            <button *ngIf="flowChartDataService.excludeHiddenQuestions && !node.item.isHidden && !isManageFields"
                    mat-menu-item class="" (click)="onAdd(node,false)"
                    matTooltip="Note: Adding a Question or Sub-Question to your Data Survey means any
                    responses given are for reference only, and will not be stored inside ITP.">
              <span>Add Field</span>
            </button>
            <button *ngIf="!node.item.isHidden && node.item.questionType!=='Field'" mat-menu-item class=""
                    (click)="editQuestion(node)">
              <span>Edit Field</span> <!--{{node.item?.questionType}}-->
            </button>
            <button
              *ngIf="flowChartDataService.excludeHiddenQuestions && !node.item.isHidden && node.item.questionType!=='Field'"
              mat-menu-item class="" (click)="delete(node)">
              <span>Delete Field</span>
            </button>
            <button *ngIf="node.item.questionType==='Field' && !node.item.frozen && !node.item.identityField"
                    mat-menu-item class="" (click)="excludeQuestion(node)">
              <span>{{node.item.isHidden ? 'Include' : 'Exclude'}}</span>
            </button>
            <button *ngIf="!node.item.isHidden" mat-menu-item class=""
                    (click)="addCondition(node,'Conditions');$event.stopPropagation();">
              <span>Conditions</span>
            </button>

          </mat-menu>
        </div>
        <div class="tags left">
          <!--          <div class="tag pointer"  (click)="addCondition(node,'Add Condition');$event.stopPropagation();" matTooltip="Click to edit the visibility conditions for this item.">-->
          <!--            {{node.item.visibilityLogicGate.visibilityType}}-->
          <!--          </div>-->
          <!--<div *ngIf="!node.item?.isCustom"  class="tag">
            <i class="fas fa-database" matTooltip="Field: Data submitted for this question will be stored in the relevant field inside ITP."></i>
          </div>-->
          <!--          <div class="tag">-->
          <!--            <i class="far fa-low-vision"  matTooltip="Question: Data submitted for this item is for reference only."></i>-->
          <!--          </div>-->
        </div>
        <div class="tags right">
          <div *ngIf="node.item.visibilityLogicGate.displayText && node.item.visibilityLogicGate.displayText.length>0"
               class="tag pointer" (click)="addCondition(node,'Add Condition');$event.stopPropagation();"
               matTooltip="{{node?.item?.visibilityLogicGate?.toolTip}}">
            {{node.item.visibilityLogicGate.displayText}}
          </div>
          <!--<div *ngIf="!node.item?.isCustom"  class="tag">
            <i class="fas fa-database" matTooltip="Field: Data submitted for this question will be stored in the relevant field inside ITP."></i>
          </div>-->
          <div *ngIf="node.item?.questionType ==='Question'" class="tag">
            <span matTooltip="Question: Data submitted for this item is for reference only.">Question</span>
          </div>
          <div *ngIf="node.item?.questionType==='Field'" class="tag">
            <span
              matTooltip="Field: Data submitted for this item can be stored in the relevant field inside ITP.">Field</span>
          </div>
          <div
            *ngIf="(node && (flowChartDataService.dataTypeConfig && flowChartDataService.dataTypeConfig.dataTypes[node.item.dataType] || node.item.dataTypeText))"
            class="tag">
            {{(flowChartDataService.dataTypeConfig && flowChartDataService.dataTypeConfig.dataTypes[node.item.dataType]) ? flowChartDataService.dataTypeConfig.dataTypes[node.item.dataType].displayText : node.item.dataTypeText}}
          </div>
        </div>
      </div>
    </mat-tree-node>

    <mat-tree-node class="custom-tree-node" [id]="node.id"
                   [ngClass]="{'control-show': node.item.id === selectedNodeId,'frozen-node':node.item.frozen==true,'excluded-item':node.item.isHidden==true || node.item.isParentHidden==true}"
                   attr.question-id="{{node.item.questionId}}" (click)="onSelectedNode(node); $event.stopPropagation();"
                   *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding cdkDrag [cdkDragData]="node"
                   (mouseenter)="dragHover(node)" (mouseleave)="dragHoverEnd()" (cdkDragStarted)="dragStart()"
                   (cdkDragReleased)="dragEnd()">

      <div class="node-wrapper w-p-100 flex flex-row justify-start items-center"
           [ngClass]="{'state-highlight': node.item.id === selectedNodeId}">
        <div class="left-section flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
          <div class="button-container">
            <button *ngIf="node.item?.children.length>0" mat-icon-button matTreeNodeToggle
                    [attr.aria-label]="'toggle ' + node.item?.title">
              <mat-icon class="mat-icon-rtl-mirror">
                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
              </mat-icon>
            </button>
          </div>

          <div class="content-container flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
            <div *ngIf="node.item?.conditionDisplayText && node.item?.conditionDisplayText.length"
                 class="tagg flex flex-row justify-start items-center">
              <div class="custom-icon flex flex-col">
                <span></span>
                <span></span>
              </div>
              {{node.item?.conditionDisplayText}}</div>
            <div class="content flex flex-row justify-start items-start full-grow-no-shrink-no-basis">
              <div>{{node.item?.questionId}}.</div>
              <div class="m-l-5">{{node.item?.title}}.</div>
              <div *ngIf="node.item?.isMandatory">&nbsp;*</div>
              <div class="description flex-1-0-auto"
                   title="{{node.item?.instruction ? node.item?.instruction : ''}}"> {{node.item?.instruction ? node.item?.instruction : ''}}</div>
            </div>
          </div>
        </div>
        <div *ngIf="isManageFields" class="right-section m-r-14">
          <button mat-icon-button [matMenuTriggerFor]="actionMenu"
                  class="no-animation-btn icon-dropdown-button">
            <mat-icon class="s-20">more_horiz</mat-icon>
          </button>
          <mat-menu #actionMenu="matMenu" class="action-button-dropdown-container" [overlapTrigger]="false">
            <button *ngIf="!node.item.isHidden" mat-menu-item class="" (click)="openDetailsPopUp(node)">
              <span>View Details</span>
            </button>
            <button mat-menu-item class="" (click)="onAdd(node,true)">
              <span>Add Field</span>
            </button>
            <button *ngIf="!node.item.isHidden && !node.item.frozen && !node.item.identityField" mat-menu-item class=""
                    (click)="editQuestion(node)">
              <span>Edit Field</span>
            </button>
            <button *ngIf="!node.item.isHidden && !node.item.frozen && !node.item.identityField && node.item.isCustom"
                    mat-menu-item class="" (click)="delete(node)">
              <span>Delete Field</span>
            </button>
            <button *ngIf="!node.item.isHidden" mat-menu-item class=""
                    (click)="moveQuestionBetweenSection(node);$event.stopPropagation();">
              <span>Move Field</span>
            </button>
          </mat-menu>
        </div>
        <div *ngIf="!isManageFields" class="right-section m-r-14">
          <button mat-icon-button [matMenuTriggerFor]="actionMenu"
                  class="no-animation-btn icon-dropdown-button">
            <mat-icon class="s-20">more_horiz</mat-icon>
          </button>
          <mat-menu #actionMenu="matMenu" class="action-button-dropdown-container" [overlapTrigger]="false">
            <button *ngIf="!node.item.isHidden" mat-menu-item class="" (click)="openDetailsPopUp(node)">
              <span>View Details</span>
            </button>

            <button *ngIf="flowChartDataService.excludeHiddenQuestions && !node.item.isHidden && !isManageFields"
                    mat-menu-item class="" (click)="onAdd(node,false)" matTooltip="Note: Adding a Question or Sub-Question to your Data Survey means any
                    responses given are for reference only, and will not be stored inside ITP.">
              <span>Add Field</span>
            </button>
            <button *ngIf="!node.item.isHidden && node.item.questionType!=='Field'" mat-menu-item class=""
                    (click)="editQuestion(node)">
              <span>Edit Field</span> <!--{{node.item?.questionType}}-->
            </button>
            <button
              *ngIf="flowChartDataService.excludeHiddenQuestions && !node.item.isHidden && node.item.questionType!=='Field'"
              mat-menu-item class="" (click)="delete(node)">
              <span>Delete Field</span>
            </button>
            <button *ngIf="node.item.questionType==='Field' && !node.item.frozen && !node.item.identityField"
                    mat-menu-item class="" (click)="excludeQuestion(node)">
              <span>{{node.item.isHidden ? 'Include Field' : 'Exclude Field'}}</span>
            </button>
            <button *ngIf="!node.item.isHidden" mat-menu-item class=""
                    (click)="addCondition(node,'Conditions');$event.stopPropagation();">
              <span>Conditions</span>
            </button>

          </mat-menu>
        </div>
        <div class="tags left">
          <!--          <div class="tag pointer"  (click)="addCondition(node,'Add Condition');$event.stopPropagation();" matTooltip="Click to edit the visibility conditions for this item.">-->
          <!--            {{node.item.visibilityLogicGate.visibilityType}}-->
          <!--          </div>-->
          <!--<div *ngIf="!node.item?.isCustom"  class="tag">
            <i class="fas fa-database" matTooltip="Field: Data submitted for this question will be stored in the relevant field inside ITP."></i>
          </div>-->
          <!--          <div class="tag">-->
          <!--            <i class="far fa-low-vision"  matTooltip="Question: Data submitted for this item is for reference only."></i>-->
          <!--          </div>-->
        </div>
        <div class="tags right">
          <div *ngIf="node.item.visibilityLogicGate.displayText && node.item.visibilityLogicGate.displayText.length>0"
               class="tag pointer" (click)="addCondition(node,'Add Condition');$event.stopPropagation();"
               matTooltip="{{node?.item?.visibilityLogicGate?.toolTip}}">
            {{node.item.visibilityLogicGate.displayText}}
          </div>
          <!--<div *ngIf="!node.item?.isCustom"  class="tag">
            <i class="fas fa-database" matTooltip="Field: Data submitted for this question will be stored in the relevant field inside ITP."></i>
          </div>-->
          <div *ngIf="node.item?.questionType ==='Question'" class="tag">
            <span matTooltip="Question: Data submitted for this item is for reference only.">Question</span>
          </div>
          <div *ngIf="node.item?.questionType==='Field'" class="tag">
            <span
              matTooltip="Field: Data submitted for this item can be stored in the relevant field inside ITP.">Field</span>
          </div>
          <div
            *ngIf="(node && (flowChartDataService.dataTypeConfig && flowChartDataService.dataTypeConfig.dataTypes[node.item.dataType] || node.item.dataTypeText))"
            class="tag">
            {{(flowChartDataService.dataTypeConfig && flowChartDataService.dataTypeConfig.dataTypes[node.item.dataType]) ? flowChartDataService.dataTypeConfig.dataTypes[node.item.dataType].displayText : node.item.dataTypeText}}
          </div>
        </div>
      </div>

    </mat-tree-node>
  </mat-tree>
</div>







